import { defineComponent as _defineComponent } from 'vue'
import message from "@/api/message";
import MessageUtil from "@/utils/Message";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import Throttle from "@/utils/Throttle";
import CopyUtils from "@/utils/CopyUtils";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import UserTools from "@/services/session/UserTools";

export default /*#__PURE__*/_defineComponent({
  __name: 'Notice',
  setup(__props) {

const pageStatus = ref(true);
const router = useRouter();
const copyContext = Throttle(async () => {
  const audio = new Audio(require("@/assets/mp3/tongzhi.mp3"));
  await audio.click();
  await audio.play();
}, 5000);
//弹出通知
const popupNotifications = async (
  title: string,
  orderId: string | number,
  requestId?: string | number
) => {
  if (!title) return;
  console.log (889999)
  if (title.endsWith("服务请求！")) {
    try {
      copyContext();
      // eslint-disable-next-line no-empty
    } catch {}
  }
  console.log(router.currentRoute.value.query.rid, requestId);
  if (router.currentRoute.value.query.rid == requestId) return;
  let notification = new Notification("企联联", {
    body: title,
    icon: "/img/login-qllLogo.f597f777.png",
    renotify: true,
    tag: "消息",
  });
  notification.onclick = function () {
    // message.MessageToTalk(requestId, orderId).then((t) => {
    //   router.push(t);
    // });
    notification.close();
  };
};
onMounted(() => {
  document.addEventListener("visibilitychange", function () {
    pageStatus.value = !document.hidden;
  });
  setInterval(() => {
    MessageUtil.getMessage(null, popupNotifications);
  }, 20000);
  MessageUtil.getMessage(null, popupNotifications);
});

return () => {}
}

})